import {isString} from 'lodash';
import sanitizeHtml from 'sanitize-html';

const NBSP_REGEX = /\u00a0/g;

export const stripHtml = (html) => {
    if (!isString(html)) {
        return html;
    }
    return sanitizeHtml(html, {allowedTags: [], allowedAttributes: {}})
        .replace(NBSP_REGEX, ' ');
};
